import { Document, Packer, Paragraph, TextRun, AlignmentType } from 'docx';
import { saveAs } from 'file-saver';

export const generateCoverLetterDocx = async (options) => {
  const { 
    applicantName = 'Applicant', 
    applicantEmail = '', 
    applicantPhone = '', 
    organization = 'Organization', 
    position = 'Position', 
    content = '', 
    addressee = 'Hiring Manager' 
  } = options;
  
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const paragraphs = content.split('\n').filter(p => p.trim());

  const doc = new Document({
    sections: [{
      children: [
        new Paragraph({ 
          children: [new TextRun({ text: applicantName, bold: true, size: 32 })], 
          alignment: AlignmentType.CENTER 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: [applicantEmail, applicantPhone].filter(Boolean).join(' | '), size: 20 })], 
          alignment: AlignmentType.CENTER, 
          spacing: { after: 400 } 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: today, size: 24 })], 
          spacing: { after: 200 } 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: addressee, size: 24 })] 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: organization, size: 24 })], 
          spacing: { after: 200 } 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: 'Re: ' + position, bold: true, size: 24 })], 
          spacing: { after: 200 } 
        }),
        ...paragraphs.map(text => new Paragraph({ 
          children: [new TextRun({ text, size: 24 })], 
          spacing: { after: 200 } 
        }))
      ]
    }]
  });

  const blob = await Packer.toBlob(doc);
  const filename = applicantName.replace(/\s+/g, '_') + '_CoverLetter_' + organization.split(' ')[0] + '.docx';
  saveAs(blob, filename);
  return filename;
};

export const generateDSDPDocx = async (options) => {
  const { clientName = 'Client', content = '' } = options;
  const paragraphs = content.split('\n').filter(p => p.trim());
  
  const doc = new Document({
    sections: [{
      children: [
        new Paragraph({ 
          children: [new TextRun({ text: 'Development Strategy & Data Plan', bold: true, size: 36 })], 
          alignment: AlignmentType.CENTER 
        }),
        new Paragraph({ 
          children: [new TextRun({ text: clientName, size: 28 })], 
          alignment: AlignmentType.CENTER, 
          spacing: { after: 400 } 
        }),
        ...paragraphs.map(text => new Paragraph({ 
          children: [new TextRun({ text, size: 24 })], 
          spacing: { after: 200 } 
        }))
      ]
    }]
  });
  
  const blob = await Packer.toBlob(doc);
  const filename = 'DSDP_' + clientName.replace(/\s+/g, '_') + '.docx';
  saveAs(blob, filename);
  return filename;
};

export default { generateCoverLetterDocx, generateDSDPDocx };
